import { IAddress } from '@faire/web-api--source/indigofair/data/IAddress';
import { IDocument } from '@faire/web-api--source/indigofair/data/IDocument';

export namespace IBrandLead {
  export enum Source {
    /**
     * buf:lint:ignore ENUM_FIRST_VALUE_ZERO
     * @deprecated
     */
    BRAND_APPLIED = 'BRAND_APPLIED',
    /**
     * @deprecated
     */
    SALES = 'SALES',
    SALES_SOURCED = 'SALES_SOURCED',
    REFERRAL = 'REFERRAL',
    LEAD_GENIUS = 'LEAD_GENIUS',
    PRODUCT_MATCHING = 'PRODUCT_MATCHING',
    EVENT = 'EVENT',
    ORGANIC = 'ORGANIC',
    DIRECT_MAIL = 'DIRECT_MAIL',
    DIGITAL_ADS = 'DIGITAL_ADS',
    PRESS = 'PRESS',
    BRAND_REFERRAL = 'BRAND_REFERRAL',
    INTERNATIONAL_TRADESHOW = 'INTERNATIONAL_TRADESHOW',
    SOCIAL_MEDIA = 'SOCIAL_MEDIA',
    RETAILER_REFERRAL = 'RETAILER_REFERRAL',
    FAIRE_EMPLOYEE = 'FAIRE_EMPLOYEE',
    MAKER_SCORING = 'MAKER_SCORING',
    CHARM_IO = 'CHARM_IO',
    OUTBOUND = 'OUTBOUND',
    OUTBOUND_OLD = 'OUTBOUND_OLD',
    FAIRE_BLOG = 'FAIRE_BLOG',
    ZOOMINFO = 'ZOOMINFO',
    PURCHASE_ORDER = 'PURCHASE_ORDER',
  }

  /**
   * Redacted copy of IBrandLead (i.e. without redacted fields).
   */
  export type Redacted = Omit<
    IBrandLead,
    | 'last_maker_application_at'
    | 'salesforce_lead_id'
    | 'created_at'
    | 'updated_at'
  >;

  /**
   * Return an instance of IBrandLead with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IBrandLead>): IBrandLead =>
    ({
      secondary_categories: [],
      ...(partial ?? {}),
    }) as IBrandLead;
}

export interface IBrandLead {
  token: string | undefined;
  brand_token: string | undefined;
  company_name: string | undefined;
  phone_number: string | undefined;
  email_address: string | undefined;
  url: string | undefined;
  url_domain: string | undefined;
  url_identifier: string | undefined;
  name: string | undefined;
  first_name: string | undefined;
  last_name: string | undefined;
  note: string | undefined;
  retailer_token: string | undefined;
  /**
   * The number of stockists (stores the brand works with) self-reported by the brand.
   * Its approximate; only a few values are available to select
   */
  number_of_stockists: number | undefined;
  /**
   * The number of products self-reported by the brand.
   * Its approximate; only a few values are available to select
   */
  number_of_products: number | undefined;
  annual_wholesale_sales_dollars: number | undefined;
  instagram_handle: string | undefined;
  product_imagery_url: string | undefined;
  product_imagery: IDocument | undefined;
  /**
   * Deprecated in favor of country and postal code.
   * @deprecated
   */
  business_address: IAddress | undefined;
  /**
   * @protobufOption (indigofair.data.redacted) = true
   */
  last_maker_application_at: number | undefined; // redacted
  source: keyof typeof IBrandLead.Source | undefined;
  source_details: string | undefined;
  /**
   * In the application we ask for the postal code or country if not in the US.
   */
  country: string | undefined;
  postal_code: string | undefined;
  referring_brand_token_alias: string | undefined;
  referring_retailer_token: string | undefined;
  catalog: IDocument | undefined;
  primary_category: string | undefined;
  /**
   * @deprecated
   */
  secondary_category: string | undefined;
  secondary_categories: Array<string>;
  /**
   * @protobufOption (indigofair.data.redacted) = true
   */
  salesforce_lead_id: string | undefined; // redacted
  has_big_box_store_stockists: boolean | undefined;
  /**
   * @protobufOption (indigofair.data.redacted) = true
   */
  created_at: number | undefined; // redacted
  /**
   * @protobufOption (indigofair.data.redacted) = true
   */
  updated_at: number | undefined; // redacted
}
